import React from "react";
import { ExportButton as MuiExportButton } from "@refinedev/mui";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { useCsvExportButtonController } from "./controller";
import { CsvExportButtonProps } from "./types";

export const CsvExportButton = <T extends Record<string, any>>({
  data,
  filename = "export.csv",
  isLoading = false,
  isDisabled = false,
}: CsvExportButtonProps<T>) => {
  const { handleExport } = useCsvExportButtonController(data, filename);

  if (!data || data.length === 0) return null;

  return (
    <MuiExportButton
      startIcon={<FileDownloadIcon />}
      onClick={handleExport}
      loading={isLoading}
      disabled={isDisabled}
    />
  );
};
